import { combineReducers } from 'redux';
import types from 'frontend/state/actionTypes';

const dataReducer = (state = [], action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_REALMS_SUCCESS:
      return payload;
    default:
      return state;
  }
};

const loadingReducer = (state = false, action = {}) => {
  const { type } = action;
  switch (type) {
    case types.FETCH_REALMS_REQUEST:
      return true;
    case types.FETCH_REALMS_SUCCESS:
    case types.FETCH_REALMS_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  data: dataReducer,
  loading: loadingReducer,
});

export const selectors = {
  realms: state => state.simbot.realms.data,
  loading: state => state.simbot.realms.loading,
};
